import { useEffect } from "react";
import { useTenantStore } from "../stores/tenantStore";

// Custom hook to provide tenant options with stable references and automatic fetch
export function useTenants(fetch = true) {
  const fetchAllTenants = useTenantStore((s) => s.fetchAllTenants);
  const isLoading = useTenantStore((s) => s.isAllTenantsLoading);
  const error = useTenantStore((s) => s.allTenantsError);
  const options = useTenantStore((s) => s.tenantOptions); // stable array reference unless data changes

  useEffect(() => {
    if (fetch && options.length === 0 && !isLoading) {
      fetchAllTenants().catch(() => {
        /* swallow; error available in store */
      });
    }
  }, [fetch, options.length, isLoading, fetchAllTenants]);

  return { options, isLoading, error, refetch: fetchAllTenants };
}
